import { render } from "./LayerItem.vue?vue&type=template&id=5644c5e7"
import script from "./LayerItem.vue?vue&type=script&lang=js"
export * from "./LayerItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__